/* yenkoes gallery carousel — shows N cards, auto-advances one every `interval` ms,
   loops seamlessly, pauses on hover, arrows step manually. No dependencies. */
(function () {
  if (window.customElements && customElements.get('yenko-carousel')) return;

  class YenkoCarousel extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.track = this.querySelector('.yk-carousel__track');
      if (!this.track) return;
      this.originals = Array.prototype.slice.call(this.track.children);
      this.count = this.originals.length;
      this.interval = parseInt(this.getAttribute('data-interval') || '3000', 10);
      this.index = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.count > 1) {
        // clone the whole set once so we can loop without a visible jump
        this.originals.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('yk-carousel__clone');
          // clones are aria-hidden: keep keyboard focus out of them
          clone.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = -1; });
          this.track.appendChild(clone);
        }, this);
      }

      var next = this.querySelector('[data-yk-next]');
      var prev = this.querySelector('[data-yk-prev]');
      if (next) next.addEventListener('click', this.step.bind(this, 1, true));
      if (prev) prev.addEventListener('click', this.step.bind(this, -1, true));

      this.addEventListener('mouseenter', this.stop.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
      this.addEventListener('focusin', this.stop.bind(this));
      this.addEventListener('focusout', this.start.bind(this));
      // no hover on touch: tapping the carousel toggles the auto-advance
      this.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'touch') return;
        if (this.timer) { this.stop(); this._touchPaused = true; }
        else if (this._touchPaused) { this.start(); this._touchPaused = false; }
      }.bind(this));
      this.track.addEventListener('transitionend', this.onEnd.bind(this));
      window.addEventListener('resize', this.position.bind(this, false));

      this.position(false);
      this.start();
    }

    metrics() {
      var first = this.originals[0];
      var w = first ? first.getBoundingClientRect().width : 0;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return w + gap;
    }

    position(animate) {
      this.track.style.transition = (animate && !this.reduce) ? 'transform .5s ease' : 'none';
      this.track.style.transform = 'translateX(' + (-this.index * this.metrics()) + 'px)';
    }

    step(dir, manual) {
      if (this.count <= 1) return;
      if (manual) this.start(); // reset the timer so a manual nudge "speeds it up"
      if (dir < 0 && this.index <= 0) {
        // wrap to the end: jump to the clone-start instantly, then animate one back
        this.index = this.count;
        this.position(false);
        this.track.getBoundingClientRect(); // force reflow so the next move animates
      }
      this.index += dir;
      this.position(true);
    }

    onEnd() {
      if (this.index >= this.count) { // landed on the clones — snap back to the real start
        this.index = 0;
        this.position(false);
      }
    }

    start() {
      if (this.reduce || this.count <= 1) return;
      this.stop();
      this.timer = setInterval(this.step.bind(this, 1, false), this.interval);
    }

    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  customElements.define('yenko-carousel', YenkoCarousel);
})();
